
import useScrollAnimation from '../../../hooks/useScrollAnimation';

export default function CallToAction() {
  const ref = useScrollAnimation();

  return (
    <section ref={ref} id="contact" className="relative py-32 bg-white overflow-hidden">
      {/* Subtle background accent */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] rounded-full bg-gradient-to-b from-horizon/40 to-transparent blur-3xl opacity-50"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-8 lg:px-12 text-center">
        <p className="animate-on-scroll text-[13px] font-medium text-anchor tracking-wide uppercase mb-5">Let\u2019s Connect</p>
        <h2 className="animate-on-scroll text-4xl md:text-5xl lg:text-[52px] font-light text-navy mb-6 tracking-tight leading-[1.1]" style={{ transitionDelay: '0.1s' }}>
          Ready for a clearer view of your operations?
        </h2>
        <p className="animate-on-scroll text-base text-navy/50 mb-12 font-light max-w-xl mx-auto leading-relaxed" style={{ transitionDelay: '0.15s' }}>
          Let\u2019s elevate your systems with intelligence designed for steady growth.
        </p>
        <div className="animate-on-scroll flex flex-col sm:flex-row items-center justify-center gap-4" style={{ transitionDelay: '0.2s' }}>
          <a
            href="mailto:contact@skysailsai.com"
            className="px-8 py-3.5 bg-navy text-white text-sm font-medium rounded-full hover:bg-navy/90 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Schedule a Strategy Call
          </a>
          <a
            href="mailto:contact@skysailsai.com"
            className="px-8 py-3.5 text-navy/60 text-sm font-medium rounded-full hover:text-navy hover:bg-drift transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            Send a Message
            <i className="ri-arrow-right-line text-base"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
